import { extractAppConfig } from '@/hooks/use-app-config';
import { SupportedLanguageType } from '@/utils/intl';
import { CustomAxiosError } from '@calm/evexia-web-sdk/generated/lib/additional-types';
import { applyTracingHeader } from '@calm/web-common/dist/tracing';
import trackAxiosError from '@rhg/libs/analytics/track-axios-error';
import {
    getNavigator,
    getRhgAppHeader,
    getRhgE2ETestHeader,
} from '@rhg/utils/browser';
import { RHG_HEADER, LANGUAGE_HEADER } from '@rhg/utils/constants';
import axios, { InternalAxiosRequestConfig } from 'axios';
import includes from 'lodash/includes';

const browserClient = axios.create();

browserClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const { NEXT_PUBLIC_SUPPORTED_LOCALES } = extractAppConfig();
    config.headers = config.headers ?? {};
    const RhgAppAppend = config.headers[RHG_HEADER.APP_APPEND] || '';
    delete config.headers[RHG_HEADER.APP_APPEND];
    config.headers[RHG_HEADER.APP] = getRhgAppHeader() + RhgAppAppend;

    // Only send the first preferred language
    const [lang] = getNavigator().language.split(/,|;|-/);
    if (includes(NEXT_PUBLIC_SUPPORTED_LOCALES, lang)) {
        config.headers[LANGUAGE_HEADER] = lang;
    } else {
        config.headers[LANGUAGE_HEADER] = SupportedLanguageType.EN;
    }

    const e2eTestHeader = getRhgE2ETestHeader();
    if (e2eTestHeader) {
        config.headers[RHG_HEADER.TEST_CASE] = e2eTestHeader;
    }
    return config;
});

browserClient.interceptors.request.use(applyTracingHeader);
browserClient.interceptors.response.use(
    (response) => response,
    (error: CustomAxiosError) => {
        if (error?.config) {
            trackAxiosError(error);
        }
        return Promise.reject(error);
    }
);

export { browserClient };
